import { inject, injectable } from "@launchtray/tsyringe-async";
import { IEmailAuthPopupController } from "./IEmailAuthPopupController";
import { Web3Model } from "../../../../../../web3/models/Web3Model";
import { IContextResolver } from "../../../../../composition/IContextResolver";
import { SceneManager } from "../../../../../../scene/SceneManager";
import { ValidationFailedPopupScene } from "../../validationfailedpopup/ValidationFailedPopupScene";
import { ILogger } from "../../../../../logger/ILogger";
import { EmailVerificationPopupScene } from "../../emailverificationpopup/EmailVerificationPopupScene";
import { Redirector } from "../../../../../../tools/Redirector";
import { IGuestModel } from "../../../../common/models/IGuestModel";

@injectable()
export class CreateWalletPopupController implements IEmailAuthPopupController {
    private readonly contextResolver: IContextResolver;
    private readonly web3Model: Web3Model;
    private readonly guestModel: IGuestModel;
    private readonly sceneManager: SceneManager;
    private readonly logger: ILogger;

    public constructor(
        @inject("IContextResolver") contextResolver: IContextResolver,
        sceneManager: SceneManager,
        web3Model: Web3Model,
        @inject("IGuestModel") guestModel: IGuestModel,
        @inject("ILogger") logger: ILogger
    ) {
        this.contextResolver = contextResolver;
        this.sceneManager = sceneManager;
        this.web3Model = web3Model;
        this.guestModel = guestModel;
        this.logger = logger;
    }

    public openIntercom(): void {
        Redirector.openIntercom(this.web3Model.email, Date.now(), this.guestModel.name.value, this.guestModel.id.value);
    }

    public async showEmailVerificationPopup(email: string): Promise<boolean> {
        try {
            const factory: (...args: any[]) => Promise<EmailVerificationPopupScene> = await this.contextResolver.resolve("EmailVerificationPopupSceneFactory");
            return await this.sceneManager.showViewableAsync(await factory(email));
        } catch (e: unknown) {
            this.logger.error(`[CreateWalletPopupController] Exception on showEmailVerificationPopup: `, e);
            return false;
        }
    }

    public async signWithEmail(email: string): Promise<void> {
        try {
            await this.web3Model.requestVerificationCode(email);
        } catch (e: unknown) {
            this.logger.debug(`[CreateWalletPopupController] Exception on requestVerificationCode: ${e}`);
            await this.showValidationFailedPopup();
        }
    }

    public async signWithPassKey(): Promise<void> {
        try {
            await this.web3Model.requestPassKeyConnection();
        } catch (e: unknown) {
            this.logger.debug(`[CreateWalletPopupController] Exception on requestVerificationCode: ${e}`);
            await this.showValidationFailedPopup();
        }
    }

    public async showValidationFailedPopup(): Promise<void> {
        try {
            const scene = await this.contextResolver.resolve(ValidationFailedPopupScene);
            await this.sceneManager.showViewableAsync(scene);
        } catch (e: unknown) {
            this.logger.error(`[CreateWalletPopupController] Exception on show validation popup: `, e);
        }
    }
}
